import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/img/icons/plus_white.svg';
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from '../../../styledComponents/buttons';
import {
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../../styledComponents/common';
import AddMasterTaskModal from './AddMasterTaskModal';
import MasterTasksFilter from './MasterTasksFilter';
import MasterTasksList from './MasterTasksList';

const MasterTasks = ({
  getMasterTasks,
  masterTasksList,
  editMasterTask,
  isLoading,
  getPublicZoneList,
  publicZoneList,
  officesShortList2,
  getOfficesShortList,
  officesShortList,
  addMasterTask,
  addTaskLoading,
}) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    publicZone: null,
    office: null,
    masterTaskName: '',
  });
  const [reload, setReload] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      // Reset edit mode and task when modal is closed
      setIsEditMode(false);
      setTaskToEdit(null);
    }
  };

  const handleEditTask = task => {
    setTaskToEdit(task);
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  // Add a function to handle the API call for adding/editing tasks with "All Offices" support
  const handleAddOrEditMasterTask = (payload) => {
    if (isEditMode && taskToEdit) {
      // For editing an existing task
      editMasterTask({
        ...payload,
        task_id: taskToEdit.id,
        callback: () => {
          toggleModal();
          setReload(!reload);
        },
      });
    } else {
      // For adding a new task
      addMasterTask({
        ...payload,
        callback: () => {
          toggleModal();
          setReload(!reload);
        },
      });
    }
  };

  useEffect(() => {
    getPublicZoneList();
  }, [getPublicZoneList]);

  useEffect(() => {
    const payload = {};
    if (filters?.publicZone?.value) {
      payload.public_zone_id = filters.publicZone.value;
    }
    if (filters?.office?.value) {
      payload.related_office = filters.office.value;
    }
    if (filters?.masterTaskName) {
      payload.name = filters.masterTaskName;
    }

    getMasterTasks(payload);
  }, [getMasterTasks, filters, reload]);

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('master_tasks')}</PageTitle>
        <ColoredButtonWithIcon
          onClick={() => {
            setIsEditMode(false);
            setTaskToEdit(null);
            toggleModal();
          }}
        >
          <ButtonIcon src={plusIcon} alt="" />
          {t('create_task')}
        </ColoredButtonWithIcon>
      </CommonGrid>
      <HeaderContainer>
        <MasterTasksFilter
          publicZoneList={publicZoneList}
          getOfficesShortList={getOfficesShortList}
          officesShortList={officesShortList}
          handleSearchByName={() => {}}
          handleClearSearch={() => {}}
          onFilterChange={setFilters}
        />
      </HeaderContainer>
      <MasterTasksList
        masterTasksList={masterTasksList}
        editMasterTask={handleEditTask}
        isLoading={isLoading}
      />

      <AddMasterTaskModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        publicZoneList={publicZoneList}
        officesShortList={officesShortList2}
        getOfficesShortList={params =>
          getOfficesShortList({ ...params, secondApi: true })
        }
        addMasterTask={handleAddOrEditMasterTask}
        isLoading={addTaskLoading}
        editMasterTask={handleAddOrEditMasterTask}
        reload={reload}
        setReload={setReload}
        isEditMode={isEditMode}
        taskToEdit={taskToEdit}
      />
    </div>
  );
};

export default MasterTasks;
